var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.711136 2.86V2.91H0.761136H8.14722H8.19722V2.86V1V0.95H8.14722H0.761136H0.711136V1V2.86ZM1.36622 7.075V7.125H1.41622H7.49213H7.54213V7.075V5.215V5.165H7.49213H1.41622H1.36622V5.215V7.075ZM0.383594 11.71V11.76H0.433594H8.47476H8.52476V11.71V9.835V9.785H8.47476H0.433594H0.383594V9.835V11.71Z",
    fill: "#00E676",
    stroke: "#00E676",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvg);
export default __webpack_public_path__ + "static/media/avg.939a0b8d9a02d9879cee115f81509c2e.svg";
export { ForwardRef as ReactComponent };